import React, { useEffect, useState } from 'react'
import '../assets/styles/CookieBanner.css'

const COOKIE_STORAGE_KEY = 'hm-cookie-consent'

export const CookieBanner = () => {
	const [isVisible, setIsVisible] = useState(false)

	useEffect(() => {
		let timerId

		const shouldShowBanner = () => {
			try {
				const storedValue = window.localStorage.getItem(COOKIE_STORAGE_KEY)
				return !storedValue
			} catch (error) {
				return true
			}
		}

		if (shouldShowBanner()) {
			timerId = window.setTimeout(() => {
				setIsVisible(true)
			}, 800)
		}

		return () => {
			if (timerId) {
				window.clearTimeout(timerId)
			}
		}
	}, [])

	const handleAccept = () => {
		try {
			window.localStorage.setItem(COOKIE_STORAGE_KEY, 'accepted')
		} catch (error) {
			// Swallow write errors (e.g. private browsing) so the banner can still dismiss
		}

		setIsVisible(false)
	}

	if (!isVisible) {
		return null
	}

	return (
		<div className="cookie-banner" role="dialog" aria-live="polite" aria-label="Cookie usage notice">
			<div className="cookie-banner__content">
				<p className="cookie-banner__description">
					We use cookies to give you the best experience. By using our website, you agree to our use of cookies in accordance with our&nbsp;
					<a className="cookie-banner__link" href="/docs/cookies_policy.pdf" target="_blank" rel="noreferrer">
						cookie policy
					</a>
					.
				</p>
				<div className="cookie-banner__actions">
					<button type="button" onClick={handleAccept} className="cookie-banner__button">
						Accept
					</button>
				</div>
			</div>
		</div>
	)
}

export default CookieBanner
